import { Component, OnInit, OnChanges, AfterViewInit, OnDestroy, ViewChild } from "@angular/core";
import { INDRAPax } from "@ibe.models/pax.indra.model.lib";
import { SidebarService } from "@ibe/services/ui";
import { ActivatedRoute, Router } from "@angular/router";
import { INDRABookingService } from "@ibe.services/booking.indra.service";
import { INDRAIbeAdminService } from "@ibe.services/ibeadmin.indra.service";
import { INDRABookedTripDetails, INDRAFareInformation } from "@ibe.models/booked-trip-details.indra.model.lib";
import { INDRABFMDataStorageService } from "@ibe.services/bfm-data-storage.indra.service";
import {
	SSR_CODES_IGNORE_LIST, TRANSLATION_ANCILLARY_GROUP, SSR_CODE_PREMIUM_CUSTOMER_CENTER, LISBON_CODE, BRAND_CODE_TOP_EXECUTIVE, BRAND_CODE_EXECUTIVE, SSR_CODE_SEAT, PAX_TYPE_INFANT_CODE, ANCILLARY_GROUP_HAND_BAGGAGE_LIST, TAP_MILES_AND_GO_FF_TIER_LEVELS, TAP_MILES_AND_GO_GOLD,
	TAP_MILES_AND_GO_SILVER,
	TAP_MILES_AND_GO_MILES,
	TAP_MILES_AND_GO_NAVIGATOR,
	ANCILLARY_GROUP_HOLD_BAGGAGE_LIST,
	TRANSLATION_ANCILLARY_DETAILED,
	SSR_CODE_BAGGAGE_FIRST_BAG,
	SSR_CODE_BAGGAGE_SECOND_BAG,
	SSR_CODE_BAGGAGE_ADDITIONAL_BAG,
	SSR_CODE_BAGGAGE_PRIORITY,
	CHECKED_BAGGAGE_FOR_INFANT_TRANSLATION_KEY,
	TAP_MILES_AND_GO_MILS,
	ANCILLARY_GROUP_SEAT_RESERVATION_LIST,
	SSR_CODE_FREE_SEAT_RESERVATION,
	SEATMAP_SEAT_TYPE_PREFERED,
	SEATMAP_SEAT_TYPE_STANDARD,
	BRAND_CODE_PLUS
} from "@ibe.config";
import { INDRAFeature } from "@ibe.components/shared/flight-brand-features-list/features.indra";
import { BehaviorSubject } from "rxjs";
import { INDRAIncludedAncillaryCodeCount } from "@ibe.models/ancillary.indra.model.lib";
import { TOP_EXECUTIVE_FEATURES } from "@ibe.components/booking/flights/brand/brand.indra";

const LOYALTY_MILES = 'loyalty--miles';

@Component({
	selector: 'app-passenger-included',
	templateUrl: './passenger-included.indra.component.html',
	styleUrls: ['./passenger-included.component.scss']
})
export class INDRAPassengerIncludedComponent
	implements OnInit, OnChanges, AfterViewInit, OnDestroy {

	isAlive = false;

	flight: any;
	flights: any[] = [];
	flightIdentifier: string;

	_printTitle;
	passengerInfo: INDRAPax;
	pnr: string;
	passenger_id: string;
	isPassengersInfoLoaded = false;
	PASSENGERS_FILTERED_INDEX: number;

	booked_trip: INDRABookedTripDetails;

	scrollingTimeout;
	isScrolling = false;

	ignoredAncillaryList: string[] = SSR_CODES_IGNORE_LIST;
	_hasFrequentFlyer: boolean;
	_logoClasses: object;
	_getLoyaltyLogo: string;
	passengerTierKey: string;
	passngerTierLabel: string;

	@ViewChild('sidebar__body') elemSidebarBody;

	// includedFeaturesIcons will be used on the checking if a certain feature has been added already on the previous iterations.
	includedFeaturesIcons = [];
	learnMoreTranslationKey = 'bookingDetails.link.learnMore';
	benefitTranslationKey = 'bookingDetails.text.benefit';
	ffTierLevel: string[] = TAP_MILES_AND_GO_FF_TIER_LEVELS;

	get passengersLength(): number {
		return this.booked_trip.data.infoPax.listPax.length;
	}

	display: boolean = true;
	isBookingPaymentPage: boolean = false;
	flightFeatures: Array<any> = [];

	constructor(
		protected sidebarService: SidebarService,
		protected route: ActivatedRoute,
		protected router: Router,
		protected bookingService: INDRABookingService,
		private ibeAdminService: INDRAIbeAdminService,
		private dataStorage: INDRABFMDataStorageService
	) {
		if ((this.router.url.includes('/booking/payment')) || (this.router.url.includes('/booking/time-to-think/payment'))) {
			this.isBookingPaymentPage = true;
			this.display = false;
		}
	}

	ngOnInit() {
		this.isAlive = true;
		this.flightIdentifier = this.route.snapshot.paramMap.get('flight');
		this.passenger_id = this.route.snapshot.paramMap.get('id');
		this.pnr = this.route.snapshot.paramMap.get('pnr');

		this.booked_trip = this.dataStorage.INDRA_getActiveBookedTrip();
		this.flight = this.bookingService.INDRA_getBookedFlight(this.flightIdentifier);
		this.PASSENGERS_FILTERED_INDEX = this.booked_trip.data.infoPax.listPax.findIndex(pax => pax.idPax.toString() === this.passenger_id);

		this.passengerInfo = this.booked_trip.data.infoPax.listPax[this.PASSENGERS_FILTERED_INDEX];
		this._printTitle = this.INDRA_printTitle();
		this.isPassengersInfoLoaded = true;
		this.flights = this.INDRA_getFlights();
		this._hasFrequentFlyer = this.INDRA_hasFrequentFlyer();
		this._logoClasses = this.INDRA_logoClasses();
		this._getLoyaltyLogo = this.INDRA_getLoyaltyLogo();
		this.passngerTierLabel = this.INDRA_getTierKeyLabel();
		this.flightFeatures = this.INDRA_getFLightFeatures();
	}

	ngOnDestroy() {
		this.isAlive = false;
	}

	ngOnChanges() {
		this.ngOnInit();
	}

	ngAfterViewInit() {
		setTimeout(() => this.scrollToFlight(), 1000);
	}

	scrollToFlight() {
		const ELEMENT_ID = 'flightItem-' + this.flightIdentifier;
		const ELEMENT = document.getElementById(ELEMENT_ID);

		if (ELEMENT != null) {
			clearTimeout(this.scrollingTimeout);
			this.isScrolling = true;

			this.scrollingTimeout = setTimeout(() => {
				this.isScrolling = false;
			}, 600);
			ELEMENT.scrollIntoView({ block: 'start', behavior: 'smooth' });
		}
	}

	// TODO modify to handle booking flo
	INDRA_printTitle() {
		if (this.isBookingPaymentPage && this.passengerInfo.surname && !isNaN(this.passengerInfo.surname as any)) {
			let key = 'addMoreSidebars.passenger.label.' + this.passengerInfo.typePax;
			return this.INDRA_getTranslationValue(key) + ' ' + this.INDRA_capitalize(this.passengerInfo.surname);
		}

		let SALUTATION = '';
		if (this.passengerInfo.title != '' || this.passengerInfo.title != undefined) {
			SALUTATION = this.passengerInfo.title;
		}

		return this.INDRA_capitalize(SALUTATION) + ' '
			+ this.INDRA_capitalize(this.passengerInfo.name) + ' '
			+ this.INDRA_capitalize(this.passengerInfo.surname);
	}

	INDRA_capitalize(str: string) {
		if (str && str.length > 0) {
			return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
		}
		return '';
	}

	/**
	 * Returns correct class with logo styles
	 */
	INDRA_logoClasses() {
		return {
			'logo__miles-go': this.passengerInfo.tierLevelFF === TAP_MILES_AND_GO_MILES || this.passengerInfo.tierLevelFF === TAP_MILES_AND_GO_MILS,
			'logo__miles-go-silver': this.passengerInfo.tierLevelFF === TAP_MILES_AND_GO_SILVER,
			'logo__miles-go-gold': this.passengerInfo.tierLevelFF === TAP_MILES_AND_GO_GOLD,
			'logo__navigator': this.passengerInfo.tierLevelFF === TAP_MILES_AND_GO_NAVIGATOR
		};
	}

	/**
	 * Returns correct frequent flyer program (Miles&Go) logo
	 */
	INDRA_getLoyaltyLogo() {
		switch (this.passengerInfo.tierLevelFF) {
			case TAP_MILES_AND_GO_MILES:
			case TAP_MILES_AND_GO_MILS:
				return 'loyalty--miles_go';
			case TAP_MILES_AND_GO_SILVER:
				return 'loyalty--miles_go_silver';
			case TAP_MILES_AND_GO_GOLD:
				return 'loyalty--miles_go_gold';
			case TAP_MILES_AND_GO_NAVIGATOR:
				return 'loyalty--navigator';
		}
		return;
	}

	/** Handles "next passenger" action intention **/
	INDRA_handleNextPassenger() {
		let nextPassengerIndex;
		if (this.isPassengersInfoLoaded) {
			const PASSENGERS_COUNT = this.booked_trip.data.infoPax.listPax.length;

			if (this.PASSENGERS_FILTERED_INDEX < PASSENGERS_COUNT - 1) {
				nextPassengerIndex = this.PASSENGERS_FILTERED_INDEX + 1;
				this.PASSENGERS_FILTERED_INDEX++;
			} else {
				nextPassengerIndex = 0;
				this.PASSENGERS_FILTERED_INDEX = 0;
			}

			// Get passenger index's ID
			const NEXT_PASSENGER_ID = this.booked_trip.data.infoPax.listPax[
				nextPassengerIndex
			].idPax;

			this.passenger_id = NEXT_PASSENGER_ID.toString();
			this.passengerInfo = this.booked_trip.data.infoPax.listPax[nextPassengerIndex];
			this._printTitle = this.INDRA_printTitle();
			this._hasFrequentFlyer = this.INDRA_hasFrequentFlyer();
			this._logoClasses = this.INDRA_logoClasses();
			this._getLoyaltyLogo = this.INDRA_getLoyaltyLogo();
			this.passngerTierLabel = this.INDRA_getTierKeyLabel();
			this.flightFeatures = this.INDRA_getFLightFeatures();

			this.elemSidebarBody.nativeElement.classList.add('animate-exit');
			this.scrollingTimeout = setTimeout(() => {
				this.sidebarService.openSidebar(['passenger-included', { flight: this.flight.assignedFlightId, pnr: this.pnr, id: this.passenger_id }]);
				this.elemSidebarBody.nativeElement.classList.add('animate-entrance');
				this.elemSidebarBody.nativeElement.classList.remove('animate-exit');
			}, 300);
		}
	}

	INDRA_nextPassengerCountLabel() {
		if (this.isPassengersInfoLoaded) {
			return (this.PASSENGERS_FILTERED_INDEX + 1 + '/' + this.booked_trip.data.infoPax.listPax.length);
		}
	}

	INDRA_getFlights() {
		let flights = [];
		if (this.booked_trip.data.fare.listOutbound) {
			this.booked_trip.data.fare.listOutbound.forEach(outbound => {
				flights.push(outbound);
			});
		}

		if (this.booked_trip.data.fare.listInbound) {
			this.booked_trip.data.fare.listInbound.forEach(inbound => {
				flights.push(inbound);
			});
		}
		return flights;
	}

	INDRA_getTranslationValueAsync(key: string) {
		return this.ibeAdminService.getTranslationValueAsync(key);
	}

	INDRA_getTranslationValue(key: string) {
		return this.ibeAdminService.getTranslationValue(key);
	}

	INDRA_getFLightFeatures() {
		const flightFeatures = [];
		this.flights.forEach(flightItem => {
			let brand = this.bookingService.INDRA_getBrandCodeFromAmadeus(flightItem.fareFamily);
			let includedFeatures = [];

			// includedFeaturesIcons will be used on the checking if a certain feature has been added already on the previous iterations.
			this.includedFeaturesIcons = [];

			includedFeatures = this.INDRA_updateIncludedFeaturesWithFareInfoFeatures(flightItem, includedFeatures);
			includedFeatures = this.INDRA_updateIncludedFeaturesWithPurchasedFeatures(flightItem, includedFeatures);
			includedFeatures = this.INDRA_updateIncludedFeaturesWithSeats(flightItem, includedFeatures);
			includedFeatures = this.INDRA_updateIncludedFeaturesWithPRM(includedFeatures);
			includedFeatures = this.INDRA_updateIncludedFeaturesWithTierBenefits(flightItem, includedFeatures);

			if (includedFeatures && includedFeatures.length > 0) {
				includedFeatures.map(feature => {

					if (feature.id == 'extraseat') {
						switch (brand) {
							case BRAND_CODE_TOP_EXECUTIVE:
							case BRAND_CODE_EXECUTIVE:
								feature.label = this.INDRA_getTranslationValueAsync('whatsIncludedSidebars.text.freeSeatReservation');
								feature.description = this.INDRA_getTranslationValue('whatsIncludedSidebars.text.inAnyArea');
								break;
							case BRAND_CODE_PLUS:
								feature.label = this.INDRA_getTranslationValueAsync('availability.flightsPage.text.comfortseatreservation');
								feature.description = this.INDRA_getTranslationValue('bookingDetails.text.extraLegroomAndReclining');
								feature.icon = 'plane_related--tap_executive';
								break;
							default:
								feature.description = this.INDRA_getTranslationValue('bookingDetails.text.freeSeatInStandardArea');
								break;
						}
					}
				});
			}

			flightFeatures.push(includedFeatures.slice());
		});


		return flightFeatures;
	}

	INDRA_getBrand(fareFamily) {
		if (!fareFamily) {
			return '';
		} else {
			return this.bookingService.INDRA_getBrandCode(fareFamily);
		}
	}

	INDRA_handleFeatureClick(action_details, flightItem) {
		this.sidebarService.openSidebar([
			action_details.route,
			{ flight: flightItem.assignedFlightId }
		]);
	}

	INDRA_updateIncludedFeaturesWithFareInfoFeatures(flightItem, includedFeatures) {
		let includedFeature = null;

		const fareInformation = this.booked_trip['fare-information'];
		const flightIdfareInformation: INDRAFareInformation = fareInformation[flightItem.idFlight];
		const flightDetails = flightItem;

		if (flightIdfareInformation) {
			flightIdfareInformation.ancillaries.forEach(ancillaryCode => {
				// skip ancillary items that belongs to the ignore list.
				if (!this.ignoredAncillaryList.includes(ancillaryCode)) {
					includedFeature = INDRAFeature.createByCode(ancillaryCode, false);

					if (includedFeature.icon != 'general--not_available') {
						let labelKey = `${TRANSLATION_ANCILLARY_GROUP + ancillaryCode}`;
						includedFeature.label = this.INDRA_getTranslationValueAsync(labelKey);
						includedFeature.details.label = this.INDRA_getTranslationValueAsync(this.learnMoreTranslationKey);

						if (!(ANCILLARY_GROUP_HAND_BAGGAGE_LIST.includes(ancillaryCode)) || (ANCILLARY_GROUP_HOLD_BAGGAGE_LIST.includes(ancillaryCode))) {
							// sets default descriptions for non hand and checked baggage feature
							includedFeature.description = this.INDRA_applyFeatureDescription(includedFeature);
						}
					} else {
						includedFeature.label = new BehaviorSubject(includedFeature.label);
						includedFeature.details.label = this.INDRA_getTranslationValueAsync(this.learnMoreTranslationKey);
					}

					let infantExcludeList = ANCILLARY_GROUP_HAND_BAGGAGE_LIST;
					if (!this.includedFeaturesIcons.includes(includedFeature.icon) || includedFeature.icon === 'general--not_available') {
						if (ancillaryCode === SSR_CODE_PREMIUM_CUSTOMER_CENTER) {
							if (this.INDRA_getBrand(flightDetails.fareFamily) === BRAND_CODE_TOP_EXECUTIVE || this.INDRA_getBrand(flightDetails.fareFamily) === BRAND_CODE_EXECUTIVE) {
								for (let segment of flightItem.listSegment) {
									if (segment.departureAirport === LISBON_CODE) {
										this.includedFeaturesIcons.push(includedFeature.icon);
										includedFeatures.push(includedFeature);
										break;
									}
								}
							}
						} else {
							// group feature is initially added on the includedFeatures..
							if (ANCILLARY_GROUP_HAND_BAGGAGE_LIST.includes(ancillaryCode)) {
								includedFeature.description = this.INDRA_getTranslationValue(`${TRANSLATION_ANCILLARY_DETAILED + ancillaryCode}`);
							}

							if (ANCILLARY_GROUP_HOLD_BAGGAGE_LIST.includes(ancillaryCode)) {
								let countUnit = this.INDRA_getTranslationValue('whatsIncludedSidebars.detailsLuggage.texts.countUnitSingular');
								if (this.passengerInfo.typePax === PAX_TYPE_INFANT_CODE) {
									// sets limitation for checked baggage of an infant
									includedFeature.description = this.INDRA_getTranslationValue(`${TRANSLATION_ANCILLARY_DETAILED + CHECKED_BAGGAGE_FOR_INFANT_TRANSLATION_KEY}`);
								} else {
									if (ancillaryCode.includes('x2') || ancillaryCode.includes('x3')) {
										includedFeature.description = this.INDRA_getTranslationValue(`${TRANSLATION_ANCILLARY_DETAILED + ancillaryCode}`);
									} else if (ancillaryCode === SSR_CODE_BAGGAGE_ADDITIONAL_BAG) {
										includedFeature.description = '1 ' + countUnit + ' ' + this.INDRA_getTranslationValue(`${TRANSLATION_ANCILLARY_DETAILED + ancillaryCode}`);
									} else {
										includedFeature.description = this.INDRA_getTranslationValue(`${TRANSLATION_ANCILLARY_DETAILED + ancillaryCode}`);
									}

								}
							}

							// hand baggage must not be present for infants..
							if (!(this.passengerInfo.typePax === PAX_TYPE_INFANT_CODE && infantExcludeList.includes(ancillaryCode))) {
								this.includedFeaturesIcons.push(includedFeature.icon);
								includedFeatures.push(includedFeature);
							}
						}
					} else {
						// this else is when the group feature has already been added on the includedFeatures..

						// updates and append actual values of ancillaries on the description of the hand baggages features..

						// hand baggage must not be present for infants..
						if (ANCILLARY_GROUP_HAND_BAGGAGE_LIST.includes(ancillaryCode) && !(this.passengerInfo.typePax === PAX_TYPE_INFANT_CODE && infantExcludeList.includes(ancillaryCode))) {
							const featureIndex = includedFeatures.findIndex(feature => feature.details.route === 'details-hand_luggage');
							if (featureIndex > -1) {
								includedFeatures[featureIndex].description = includedFeatures[featureIndex].description + ', ' + this.INDRA_getTranslationValue(`${TRANSLATION_ANCILLARY_DETAILED + ancillaryCode}`);
							}
						}

						// updates and appends actual values of ancillaries on the description of the checked baggages features..
						if (ANCILLARY_GROUP_HOLD_BAGGAGE_LIST.includes(ancillaryCode)) {
							let countUnit = this.INDRA_getTranslationValue('whatsIncludedSidebars.detailsLuggage.texts.countUnitSingular');
							const featureIndex = includedFeatures.findIndex(feature => feature.details.route === 'details-luggage');
							if (this.passengerInfo.typePax === PAX_TYPE_INFANT_CODE) {
								// sets limitation for checked baggage of an infant
								includedFeature.description = this.INDRA_getTranslationValue(`${TRANSLATION_ANCILLARY_DETAILED + CHECKED_BAGGAGE_FOR_INFANT_TRANSLATION_KEY}`);
							} else {
								if (featureIndex > -1) {
									if (ancillaryCode.includes('x2') || ancillaryCode.includes('x3')) {
										includedFeatures[featureIndex].description = includedFeatures[featureIndex].description + ', ' + this.INDRA_getTranslationValue(`${TRANSLATION_ANCILLARY_DETAILED + ancillaryCode}`);
									} else if (ancillaryCode === SSR_CODE_BAGGAGE_ADDITIONAL_BAG) {
										includedFeatures[featureIndex].description = includedFeatures[featureIndex].description + ', 1 ' + countUnit + ' ' + this.INDRA_getTranslationValue(`${TRANSLATION_ANCILLARY_DETAILED + ancillaryCode}`);
									} else {
										includedFeatures[featureIndex].description = includedFeatures[featureIndex].description + ', ' + this.INDRA_getTranslationValue(`${TRANSLATION_ANCILLARY_DETAILED + ancillaryCode}`);
									}
								}
							}
						}
					}
				}

			});

			// miles will be displayed only on the first card created for the flight id.
			//let firstCardOfTheFlightFlag = this.bookingService.INDRA_checkFlightCardIfFirstCardOfTheFlight(flightItem.assignedFlightId, flightItem.idFlight);

			if (flightIdfareInformation.miles) {
				let miles = this.bookingService.INDRA_getLoyaltyMilesPerTierByFlightCardId(flightItem.idFlight, this.passengerInfo.tierLevelFF, flightItem.assignedFlightId);
				includedFeature = INDRAFeature.getLoyaltyMiles(miles.toString(), false);
				includedFeature.details.label = this.INDRA_getTranslationValueAsync(this.learnMoreTranslationKey);
				includedFeature.label = this.INDRA_getTranslationValueAsync(TRANSLATION_ANCILLARY_GROUP + 'miles');
				includedFeature.description = this.INDRA_applyFeatureDescription(includedFeature);
				includedFeatures.push(includedFeature);
			}

		}
		return includedFeatures.slice();
	}

	INDRA_updateIncludedFeaturesWithTierBenefits(flightItem, includedFeatures) {
		let includedFeature = null;

		const tierInformation = this.booked_trip['tier-information'];
		if (!tierInformation) {
			return includedFeatures;
		}
		const tierBenefits = tierInformation[this.passengerInfo['tierLevelFF']];
		const flightDetails = flightItem;

		if (tierBenefits && tierBenefits.ancillaries) {
			tierBenefits.ancillaries.forEach(ancillaryCode => {
				// skip ancillary items that belongs to the ignore list.
				if (!this.ignoredAncillaryList.includes(ancillaryCode)) {
					includedFeature = INDRAFeature.createByCode(ancillaryCode, false);

					if (includedFeature.icon != 'general--not_available') {
						let labelKey = `${TRANSLATION_ANCILLARY_GROUP + ancillaryCode}`;
						includedFeature.label = this.INDRA_getTranslationValueAsync(labelKey);
						includedFeature.details.label = this.INDRA_getTranslationValueAsync(this.learnMoreTranslationKey);

						if (!(ANCILLARY_GROUP_HAND_BAGGAGE_LIST.includes(ancillaryCode)) || (ANCILLARY_GROUP_HOLD_BAGGAGE_LIST.includes(ancillaryCode))) {
							// sets default descriptions for non hand and checked baggage feature
							includedFeature.description = this.INDRA_applyFeatureDescription(includedFeature);
						}
					} else {
						includedFeature.label = new BehaviorSubject(includedFeature.label);
						includedFeature.details.label = this.INDRA_getTranslationValueAsync(this.learnMoreTranslationKey);
					}

					if (!this.includedFeaturesIcons.includes(includedFeature.icon) || includedFeature.icon === 'general--not_available') {
						if (ancillaryCode === SSR_CODE_PREMIUM_CUSTOMER_CENTER) {
							if (this.INDRA_getBrand(flightDetails.fareFamily) === BRAND_CODE_TOP_EXECUTIVE || this.INDRA_getBrand(flightDetails.fareFamily) === BRAND_CODE_EXECUTIVE) {
								for (let segment of flightItem.listSegment) {
									if (segment.departureAirport === LISBON_CODE) {
										this.includedFeaturesIcons.push(includedFeature.icon);
										includedFeatures.push(includedFeature);
										break;
									}
								}
							}
						} else {
							// group feature is initially added on the includedFeatures..
							if (ANCILLARY_GROUP_HAND_BAGGAGE_LIST.includes(ancillaryCode)) {
								includedFeature.description = this.INDRA_getTranslationValue(`${TRANSLATION_ANCILLARY_DETAILED + ancillaryCode}`) +
									' (' + this.passngerTierLabel + ' ' + this.INDRA_getTranslationValue(this.benefitTranslationKey) + ')';
							}

							if (ANCILLARY_GROUP_HOLD_BAGGAGE_LIST.includes(ancillaryCode)) {
								let countUnit = this.INDRA_getTranslationValue('whatsIncludedSidebars.detailsLuggage.texts.countUnitSingular');
								if (this.passengerInfo.typePax !== PAX_TYPE_INFANT_CODE) {
									if (ancillaryCode.includes('x2') || ancillaryCode.includes('x3')) {
										includedFeature.description = this.INDRA_getTranslationValue(`${TRANSLATION_ANCILLARY_DETAILED + ancillaryCode}`) +
											' (' + this.passngerTierLabel + ' ' + this.INDRA_getTranslationValue(this.benefitTranslationKey) + ')';
									} else if (ancillaryCode === SSR_CODE_BAGGAGE_ADDITIONAL_BAG) {
										includedFeature.description = '1 ' + countUnit + ' ' + this.INDRA_getTranslationValue(`${TRANSLATION_ANCILLARY_DETAILED + ancillaryCode}`) +
											' (' + this.passngerTierLabel + ' ' + this.INDRA_getTranslationValue(this.benefitTranslationKey) + ')';
									} else {
										includedFeature.description = this.INDRA_getTranslationValue(`${TRANSLATION_ANCILLARY_DETAILED + ancillaryCode}`)
											+ ' (' + this.passngerTierLabel + ' ' + this.INDRA_getTranslationValue(this.benefitTranslationKey) + ')';
									}

								}
							}

							this.includedFeaturesIcons.push(includedFeature.icon);
							includedFeatures.push(includedFeature);
						}
					} else {
						// this else is when the group feature has already been added on the includedFeatures..

						// updates and append actual values of ancillaries on the description of the hand baggages features...
						if (ANCILLARY_GROUP_HAND_BAGGAGE_LIST.includes(ancillaryCode)) {
							const featureIndex = includedFeatures.findIndex(feature => feature.details.route === 'details-hand_luggage');
							if (featureIndex > -1) {
								includedFeatures[featureIndex].description = includedFeatures[featureIndex].description + ', ' + this.INDRA_getTranslationValue(`${TRANSLATION_ANCILLARY_DETAILED + ancillaryCode}`) +
									' (' + this.passngerTierLabel + ' ' + this.INDRA_getTranslationValue(this.benefitTranslationKey) + ')';
							}
						}

						// updates and appends actual values of ancillaries on the description of the checked baggages features..
						if (ANCILLARY_GROUP_HOLD_BAGGAGE_LIST.includes(ancillaryCode)) {
							let countUnit = this.INDRA_getTranslationValue('whatsIncludedSidebars.detailsLuggage.texts.countUnitSingular');
							const featureIndex = includedFeatures.findIndex(feature => feature.details.route === 'details-luggage');
							/* if (this.passengerInfo.typePax == PAX_TYPE_INFANT_CODE) {
								// sets limitation for checked baggage of an infant
								includedFeature.description = this.INDRA_getTranslationValue(`${TRANSLATION_ANCILLARY_DETAILED + CHECKED_BAGGAGE_FOR_INFANT_TRANSLATION_KEY}`);
							} else { */
							if (featureIndex > -1) {
								if (ancillaryCode.includes('x2') || ancillaryCode.includes('x3')) {
									includedFeatures[featureIndex].description = includedFeatures[featureIndex].description + ', ' + this.INDRA_getTranslationValue(`${TRANSLATION_ANCILLARY_DETAILED + ancillaryCode}`) +
										' (' + this.passngerTierLabel + ' ' + this.INDRA_getTranslationValue(this.benefitTranslationKey) + ')';
								} else if (ancillaryCode === SSR_CODE_BAGGAGE_ADDITIONAL_BAG) {
									includedFeatures[featureIndex].description = includedFeatures[featureIndex].description + ', 1 ' + countUnit + ' ' + this.INDRA_getTranslationValue(`${TRANSLATION_ANCILLARY_DETAILED + ancillaryCode}`) +
										' (' + this.passngerTierLabel + ' ' + this.INDRA_getTranslationValue(this.benefitTranslationKey) + ')';
								} else {
									includedFeatures[featureIndex].description = includedFeatures[featureIndex].description + ', ' + this.INDRA_getTranslationValue(`${TRANSLATION_ANCILLARY_DETAILED + ancillaryCode}`) +
										' (' + this.passngerTierLabel + ' ' + this.INDRA_getTranslationValue(this.benefitTranslationKey) + ')';
								}
							}
							// }
						}
					}
				}

			});
		}

		return includedFeatures.slice();
	}

	private getMilesPercentage(tierBenefits: any) {
		return tierBenefits && tierBenefits['milesPercentage'] ? parseFloat(tierBenefits['milesPercentage']) : 0;
	}

	INDRA_updateIncludedFeaturesWithPurchasedFeatures(flightItem, includedFeatures) {
		let purchasedFeature = null;
		const segmentIDs = this.INDRA_getSegmentIDs(flightItem);
		let handBaggageCountArray: INDRAIncludedAncillaryCodeCount[] = [];
		let checkedBaggageCountArray: INDRAIncludedAncillaryCodeCount[] = [];

		if (this.booked_trip.data.ancillaries.ancillaries && this.booked_trip.data.ancillaries.ancillaries.length > 0) {
			this.booked_trip.data.ancillaries.ancillaries.forEach(ancillary => {
				ancillary.journey.forEach(journeyItem => {
					if (journeyItem.flightId === flightItem.idFlight.toString() && segmentIDs.includes(journeyItem.segmentId)) {
						journeyItem.passengers.forEach(pax => {
							if (pax.paxId === this.passenger_id) {
								pax.ancillaryInfo.forEach(ancillaryInfoItem => {
									// skip ancillary items that belongs to the ignore list.
									if (!this.ignoredAncillaryList.includes(ancillaryInfoItem.code)) {
										purchasedFeature = INDRAFeature.createByCode(ancillaryInfoItem.code, false);
										if (purchasedFeature.icon != 'general--not_available') {
											let labelKey = `${TRANSLATION_ANCILLARY_GROUP + ancillaryInfoItem.code}`;
											purchasedFeature.label = this.INDRA_getTranslationValueAsync(labelKey);
											purchasedFeature.details.label = this.INDRA_getTranslationValueAsync(this.learnMoreTranslationKey);

											if (ANCILLARY_GROUP_HAND_BAGGAGE_LIST.includes(ancillaryInfoItem.code)) {
												const firstSegmentId = this.bookingService.INDRA_getFirstSegmentByFlightCard(flightItem.assignedFlightId);
												if (firstSegmentId.toString() === journeyItem.segmentId) {
													let handBaggageIndex = handBaggageCountArray.findIndex(handBaggageItem => handBaggageItem.code === ancillaryInfoItem.code);
													if (handBaggageIndex === -1) {
														handBaggageCountArray.push({
															code: ancillaryInfoItem.code,
															count: ancillaryInfoItem.quantity
														});
													} else {
														handBaggageCountArray[handBaggageIndex].count = handBaggageCountArray[handBaggageIndex].count + ancillaryInfoItem.quantity;
													}
												}
											} else if (ANCILLARY_GROUP_HOLD_BAGGAGE_LIST.includes(ancillaryInfoItem.code)) {
												const firstSegmentId = this.bookingService.INDRA_getFirstSegmentByFlightCard(flightItem.assignedFlightId);
												if (firstSegmentId.toString() === journeyItem.segmentId) {
													let checkedBaggageIndex = checkedBaggageCountArray.findIndex(checkedBaggageItem => checkedBaggageItem.code === ancillaryInfoItem.code);
													if (checkedBaggageIndex === -1) {
														checkedBaggageCountArray.push({
															code: ancillaryInfoItem.code,
															count: ancillaryInfoItem.quantity
														});
													} else {
														checkedBaggageCountArray[checkedBaggageIndex].count = checkedBaggageCountArray[checkedBaggageIndex].count + ancillaryInfoItem.quantity;
													}
												}
											} else {
												// sets default descriptions for non hand and checked baggage feature
												purchasedFeature.description = this.INDRA_applyFeatureDescription(purchasedFeature);
											}
										} else {
											purchasedFeature.label = new BehaviorSubject(purchasedFeature.label);
											purchasedFeature.details.label = this.INDRA_getTranslationValueAsync(this.learnMoreTranslationKey);
										}

										if (!this.includedFeaturesIcons.includes(purchasedFeature.icon) || purchasedFeature.icon === 'general--not_available') {
											this.includedFeaturesIcons.push(purchasedFeature.icon);
											includedFeatures.push(purchasedFeature);
										}
									}
								});
							}
						});
					}
				});
			});
		}

		if (checkedBaggageCountArray.length > 0) {
			let featureIndex = includedFeatures.findIndex(feature => feature.details.route === 'details-luggage');
			let constructedAncillaryList = '';
			constructedAncillaryList = this.INDRA_constructAncillaryListForCheckedBaggage(checkedBaggageCountArray);
			if (constructedAncillaryList.length > 0) {
				includedFeatures[featureIndex].description.length === 0 ? (includedFeatures[featureIndex].description = constructedAncillaryList) : (includedFeatures[featureIndex].description = includedFeatures[featureIndex].description + ', ' + constructedAncillaryList);
			}
		}

		if (handBaggageCountArray.length > 0) {
			let featureIndex = includedFeatures.findIndex(feature => feature.details.route === 'details-hand_luggage');
			let constructedAncillaryList = '';
			constructedAncillaryList = this.INDRA_constructAncillaryListForHandBaggage(handBaggageCountArray);
			if (constructedAncillaryList.length > 0) {
				includedFeatures[featureIndex].description.length === 0 ? (includedFeatures[featureIndex].description = constructedAncillaryList) : (includedFeatures[featureIndex].description = includedFeatures[featureIndex].description + ', ' + constructedAncillaryList);
			}
		}
		return includedFeatures.slice();
	}

	INDRA_constructAncillaryListForCheckedBaggage(checkedBaggageCountArray: INDRAIncludedAncillaryCodeCount[]): string {
		let constructedAncillaryList = '';
		let fbag = '';
		let sbag = '';
		let xbag = '';
		let others = '';
		let pbag = '';
		let countUnit = this.INDRA_getTranslationValue('whatsIncludedSidebars.detailsLuggage.texts.countUnitSingular');
		checkedBaggageCountArray.forEach(checkedBaggageItem => {
			if (checkedBaggageItem.code == (SSR_CODE_BAGGAGE_FIRST_BAG)) {
				if (fbag.length === 0) {
					fbag = this.INDRA_getTranslationValue(`${TRANSLATION_ANCILLARY_DETAILED + checkedBaggageItem.code}`);
				} else {
					fbag = fbag + ', ' + this.INDRA_getTranslationValue(`${TRANSLATION_ANCILLARY_DETAILED + checkedBaggageItem.code}`);
				}
			}
			else if (checkedBaggageItem.code == SSR_CODE_BAGGAGE_SECOND_BAG) {
				if (sbag.length === 0) {
					sbag = this.INDRA_getTranslationValue(`${TRANSLATION_ANCILLARY_DETAILED + checkedBaggageItem.code}`);
				} else {
					sbag = sbag + ', ' + this.INDRA_getTranslationValue(`${TRANSLATION_ANCILLARY_DETAILED + checkedBaggageItem.code}`);
				}
			}
			else if (checkedBaggageItem.code == SSR_CODE_BAGGAGE_ADDITIONAL_BAG) {
				let xCount = this.INDRA_getTranslationValue('whatsIncludedSidebars.detailsLuggage.texts.countUnitPlural');
				if (checkedBaggageItem.count == 1) {
					xCount = countUnit;
				}
				if (xbag.length === 0) {
					xbag = checkedBaggageItem.count + ' ' + xCount + ' ' + this.INDRA_getTranslationValue(`${TRANSLATION_ANCILLARY_DETAILED + checkedBaggageItem.code}`);
				} else {
					xbag = xbag + ', ' + checkedBaggageItem.count + ' ' + xCount + ' ' + this.INDRA_getTranslationValue(`${TRANSLATION_ANCILLARY_DETAILED + checkedBaggageItem.code}`);
				}
			} else if (checkedBaggageItem.code == SSR_CODE_BAGGAGE_PRIORITY) {
				pbag = this.INDRA_getTranslationValue(`${TRANSLATION_ANCILLARY_DETAILED + checkedBaggageItem.code}`);
			} else {
				// direct from translation (ancillay codes with multipliers)
				others = this.INDRA_getTranslationValue(`${TRANSLATION_ANCILLARY_DETAILED + checkedBaggageItem.code}`);
			}
		});

		if (fbag.length > 0) {
			constructedAncillaryList.length === 0 ? (constructedAncillaryList = fbag) : (constructedAncillaryList = constructedAncillaryList + ', ' + fbag);
		}

		if (others.length > 0) {
			constructedAncillaryList.length === 0 ? (constructedAncillaryList = others) : (constructedAncillaryList = constructedAncillaryList + ', ' + others);
		}

		if (sbag.length > 0) {
			constructedAncillaryList.length === 0 ? (constructedAncillaryList = sbag) : (constructedAncillaryList = constructedAncillaryList + ', ' + sbag);
		}

		if (xbag.length > 0) {
			constructedAncillaryList.length === 0 ? (constructedAncillaryList = xbag) : (constructedAncillaryList = constructedAncillaryList + ', ' + xbag);
		}

		if (pbag.length > 0) {
			constructedAncillaryList.length === 0 ? (constructedAncillaryList = pbag) : (constructedAncillaryList = constructedAncillaryList + ', ' + pbag);
		}
		return constructedAncillaryList;
	}

	INDRA_constructAncillaryListForHandBaggage(ancillaryArray: INDRAIncludedAncillaryCodeCount[]) {
		let constructedAncillaryList = '';
		ancillaryArray.forEach(ancillaryItem => {
			if (constructedAncillaryList.length === 0) {
				constructedAncillaryList = this.INDRA_getTranslationValue(`${TRANSLATION_ANCILLARY_DETAILED + ancillaryItem.code}`);
			} else {
				constructedAncillaryList = constructedAncillaryList + ', ' + this.INDRA_getTranslationValue(`${TRANSLATION_ANCILLARY_DETAILED + ancillaryItem.code}`);
			}

		});
		return constructedAncillaryList;
	}

	INDRA_updateIncludedFeaturesWithSeats(flightItem, includedFeatures) {
		let purchasedFeature = null;
		const segmentIDs = this.INDRA_getSegmentIDs(flightItem);
		let seatFound = false;
		this.booked_trip.data.ancillaries.seat.journey.forEach(seat => {
			if (seat) {
				if (seat.flightId === flightItem.idFlight.toString() && segmentIDs.includes(seat.segmentId)) {
					seat.passengers.forEach(pax => {
						if (pax.paxId === this.passenger_id) {
							pax.ancillaryInfo.forEach(seatInfoItem => {
								if (seatInfoItem.code === SSR_CODE_SEAT) {
									purchasedFeature = INDRAFeature.createByCode(seatInfoItem.code, false);
									let labelKey = `${TRANSLATION_ANCILLARY_GROUP + seatInfoItem.code}`;
									purchasedFeature.label = this.INDRA_getTranslationValueAsync(labelKey);
									purchasedFeature.details.label = this.INDRA_getTranslationValueAsync(this.learnMoreTranslationKey);
									purchasedFeature.description = seatInfoItem.seatCode;
									seatFound = true;
									if (!this.includedFeaturesIcons.includes(purchasedFeature.icon) || purchasedFeature.icon === 'general--not_available') {
										this.includedFeaturesIcons.push(purchasedFeature.icon);
										includedFeatures.push(purchasedFeature);
									} else {
										const seatIndex = includedFeatures.findIndex((feature) => {
											return feature.icon === purchasedFeature.icon;
										});
										includedFeatures[seatIndex].label = purchasedFeature.label;
										includedFeatures[seatIndex].description = purchasedFeature.description;
										includedFeatures[seatIndex].details.label = purchasedFeature.details.label;
									}

								}
							});
						}
					});
				}
			}
		});

		let brandHasSeat = false;
		if (this.booked_trip["fare-information"][flightItem.idFlight.toString()]) {
			const fareInfoAncillaries = this.booked_trip["fare-information"][flightItem.idFlight.toString()].ancillaries;
			let brandHasSeat = fareInfoAncillaries.some((elements) => {
				return ANCILLARY_GROUP_SEAT_RESERVATION_LIST.includes(elements);
			});
		}

		if (!seatFound && brandHasSeat) {
			purchasedFeature = INDRAFeature.createByCode(SSR_CODE_SEAT, false);
			if (!this.includedFeaturesIcons.includes(purchasedFeature.icon) || purchasedFeature.icon === 'general--not_available') {
				let labelKey = `${TRANSLATION_ANCILLARY_GROUP + SSR_CODE_SEAT}`;
				purchasedFeature.label = this.INDRA_getTranslationValueAsync(labelKey);
				purchasedFeature.details.label = this.INDRA_getTranslationValueAsync(this.learnMoreTranslationKey);
				purchasedFeature.description = this.INDRA_applyFeatureDescription(purchasedFeature);
				includedFeatures.push(purchasedFeature);
			}
		}

		return includedFeatures.slice();
	}

	INDRA_updateIncludedFeaturesWithPRM(includedFeatures) {
		let purchasedFeature = null;
		let tmp_pmrAncillaryList = [];
		if (this.passengerInfo.prm) {
			this.passengerInfo.prm.forEach(
				prm => {
					purchasedFeature = INDRAFeature.createByCode(prm.type, false);
					let labelKey = `${TRANSLATION_ANCILLARY_GROUP + prm.type}`;
					purchasedFeature.label = this.INDRA_getTranslationValueAsync(labelKey);
					purchasedFeature.details.label = this.INDRA_getTranslationValueAsync(this.learnMoreTranslationKey);
					if (!this.includedFeaturesIcons.includes(purchasedFeature.icon) || purchasedFeature.icon === 'general--not_available') {
						if (!this.ignoredAncillaryList.includes(prm.type)) {
							if (!tmp_pmrAncillaryList.includes(prm.type)) {
								this.includedFeaturesIcons.push(purchasedFeature.icon);
								tmp_pmrAncillaryList.push(prm.type);
								includedFeatures.push(purchasedFeature);
							}
						}
					}
				}
			)
		}
		return includedFeatures.slice();
	}

	INDRA_getSegmentIDs(flightItem): string[] {
		return flightItem.listSegment.map(segment => segment.idInfoSegment + '');
	}

	INDRA_hasFrequentFlyer() {
		return ((this.passengerInfo.tierLevelFF) && this.ffTierLevel.includes(this.passengerInfo.tierLevelFF));
	}

	INDRA_applyFeatureDescription(feature) {
		this.flightIdentifier = this.route.snapshot.paramMap.get('flight');
		const hasPreferredSeats = this.bookingService.INDRA_hasAncillary(SSR_CODE_FREE_SEAT_RESERVATION, this.flightIdentifier);
		switch (feature.details.route) {
			case ('details-loyalty_miles'):
				return this.INDRA_getTranslationValue('bookingDetails.text.forMilesAndGoOnly');
			case ('details-snacks'):
				return this.INDRA_getTranslationValue('bookingDetails.text.mayIncludeDairyAndAllergens');
			case ('details-seat'):
				if (this.INDRA_getBrand(this.flight.fareFamily) === BRAND_CODE_EXECUTIVE || this.INDRA_getBrand(this.flight.fareFamily) === BRAND_CODE_TOP_EXECUTIVE) {
					return this.INDRA_getTranslationValue('bookingDetails.text.seatInExecutiveArea')
				} else {
					return hasPreferredSeats ? this.INDRA_getTranslationValue('bookingDetails.text.seatInPreferredArea') : this.INDRA_getTranslationValue('bookingDetails.text.freeSeatInStandardArea');
				}

			case ('details-fast_track'):
				return this.INDRA_getTranslationValue('bookingDetails.text.allPassengersGetFasterThroughSecurity');
			case ('details-lounge'):
				return this.INDRA_getTranslationValue('bookingDetails.text.accessLounge');
			default:
				return '';
		}
	}

	INDRA_displayFeatureDescriptionSuffix(feature) {
		switch (feature.details.route) {
			case ('details-hand_luggage'):
				return true;
			case ('details-luggage'):
				return true;
			default:
				return false;
		}
	}

	INDRA_printFeatureDescriptionSuffix(feature) {
		switch (feature.details.route) {
			case ('details-hand_luggage'):
				return this.INDRA_getTranslationValue('whatsIncludedSidebars.detailsHandLuggage.text.personalItemInclusion') + ' ' + this.INDRA_getTranslationValue('bookingDetails.text.allowed');
			case ('details-luggage'):
				return this.INDRA_getTranslationValue('bookingDetails.text.allowed');
			default:
				return false;
		}
	}

	/**
	 * Returns label for tier level
	 */
	INDRA_getTierKeyLabel() {
		return this.bookingService.INDRA_getTierKeyLabel(this.passengerInfo);
	}

	/** Handles close action intention **/
	INDRA_handleClose() {
		this.sidebarService.closeSidebar();
		this.router.navigate([{ outlets: { sidebar: null } }], { replaceUrl: true });
	}
}
